var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrainingRaiseVoiceV3(_ref, svgRef) {
  var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17;
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.49689C13.0195 2.49689 15.7042 4.30005 16.8802 7.00544",
    stroke: "#7A7670",
    style: (_ref2 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref2, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref2, "strokeOpacity", 1), _ref2),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0414 17.706C10.0414 17.729 10.0227 17.7476 9.99971 17.7476C9.9767 17.7476 9.95805 17.7289 9.95804 17.7059C9.95803 17.6829 9.97667 17.6642 9.99968 17.6642C10.0107 17.6642 10.0214 17.6686 10.0292 17.6764C10.037 17.6843 10.0414 17.6949 10.0414 17.706",
    stroke: "#7A7670",
    style: (_ref3 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref3, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref3, "strokeOpacity", 1), _ref3),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8959 16.8723C12.8959 16.8953 12.8772 16.914 12.8542 16.914C12.8312 16.914 12.8125 16.8953 12.8125 16.8723C12.8125 16.8493 12.8312 16.8306 12.8542 16.8306C12.8652 16.8306 12.8759 16.835 12.8837 16.8428C12.8915 16.8506 12.8959 16.8613 12.8959 16.8723",
    stroke: "#7A7670",
    style: (_ref4 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref4, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref4, "strokeOpacity", 1), _ref4),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14834 12.8554C3.14832 12.8784 3.12965 12.8971 3.10664 12.8971C3.08363 12.8971 3.06498 12.8784 3.06498 12.8554C3.06497 12.8324 3.0836 12.8137 3.10661 12.8137C3.11768 12.8137 3.12831 12.8181 3.13613 12.8259C3.14396 12.8337 3.14836 12.8444 3.14834 12.8554",
    stroke: "#7A7670",
    style: (_ref5 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref5, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref5, "strokeOpacity", 1), _ref5),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76602 15.3518C4.76599 15.3748 4.74733 15.3934 4.72432 15.3934C4.70131 15.3934 4.68266 15.3747 4.68265 15.3517C4.68264 15.3287 4.70128 15.3101 4.72429 15.31C4.73536 15.31 4.74598 15.3144 4.75381 15.3222C4.76164 15.3301 4.76603 15.3407 4.76602 15.3518",
    stroke: "#7A7670",
    style: (_ref6 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref6, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref6, "strokeOpacity", 1), _ref6),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18643 16.8723C7.1864 16.8953 7.16774 16.9139 7.14473 16.9139C7.12172 16.9139 7.10307 16.8952 7.10306 16.8722C7.10305 16.8492 7.12169 16.8306 7.1447 16.8305C7.15577 16.8305 7.16639 16.8349 7.17422 16.8427C7.18205 16.8506 7.18644 16.8612 7.18643 16.8723",
    stroke: "#7A7670",
    style: (_ref7 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref7, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref7, "strokeOpacity", 1), _ref7),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58047 10C2.58044 10.023 2.56178 10.0417 2.53877 10.0417C2.51576 10.0416 2.49711 10.023 2.4971 9.99999C2.4971 9.97698 2.51573 9.95831 2.53874 9.95829C2.54981 9.95827 2.56043 9.96267 2.56826 9.9705C2.57609 9.97832 2.58049 9.98895 2.58047 10",
    stroke: "#7A7670",
    style: (_ref8 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref8, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref8, "strokeOpacity", 1), _ref8),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14834 7.14462C3.14834 7.16764 3.12969 7.1863 3.10668 7.18631C3.08366 7.18632 3.06499 7.16767 3.06498 7.14466C3.06496 7.12164 3.08359 7.10297 3.10661 7.10294C3.11768 7.10293 3.12831 7.10732 3.13614 7.11515C3.14397 7.12298 3.14836 7.13361 3.14834 7.14468",
    stroke: "#7A7670",
    style: (_ref9 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref9, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref9, "strokeOpacity", 1), _ref9),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.76602 4.72403C4.76599 4.74703 4.74732 4.76566 4.72432 4.76565C4.70131 4.76564 4.68266 4.74699 4.68265 4.72399C4.68264 4.70098 4.70127 4.68232 4.72428 4.68229C4.73535 4.68227 4.74598 4.68666 4.75381 4.69449C4.76164 4.70233 4.76603 4.71295 4.76602 4.72403",
    stroke: "#7A7670",
    style: (_ref10 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref10, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref10, "strokeOpacity", 1), _ref10),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18642 3.10659C7.18639 3.1296 7.16773 3.14823 7.14472 3.14822C7.12171 3.14821 7.10306 3.12956 7.10305 3.10655C7.10305 3.08354 7.12169 3.06488 7.1447 3.06485C7.15577 3.06484 7.16639 3.06923 7.17423 3.07706C7.18206 3.08489 7.18645 3.09551 7.18644 3.10659",
    stroke: "#7A7670",
    style: (_ref11 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref11, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref11, "strokeOpacity", 1), _ref11),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8507 12.8555C16.8507 12.8785 16.8694 12.8971 16.8924 12.8971C16.9154 12.8971 16.934 12.8785 16.934 12.8555C16.9341 12.8324 16.9154 12.8138 16.8924 12.8138C16.8813 12.8137 16.8707 12.8181 16.8629 12.826C16.8551 12.8338 16.8507 12.8444 16.8507 12.8555",
    stroke: "#7A7670",
    style: (_ref12 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref12, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref12, "strokeOpacity", 1), _ref12),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.233 15.3518C15.233 15.3748 15.2517 15.3935 15.2747 15.3935C15.2977 15.3935 15.3164 15.3748 15.3164 15.3518C15.3164 15.3288 15.2977 15.3101 15.2747 15.3101C15.2637 15.3101 15.253 15.3145 15.2452 15.3223C15.2374 15.3301 15.233 15.3408 15.233 15.3518",
    stroke: "#7A7670",
    style: (_ref13 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref13, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref13, "strokeOpacity", 1), _ref13),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8126 16.8723C12.8126 16.8953 12.8313 16.914 12.8543 16.914C12.8773 16.914 12.896 16.8953 12.896 16.8723C12.896 16.8493 12.8773 16.8306 12.8543 16.8306C12.8433 16.8306 12.8326 16.835 12.8248 16.8428C12.817 16.8506 12.8126 16.8613 12.8126 16.8723",
    stroke: "#7A7670",
    style: (_ref14 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref14, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref14, "strokeOpacity", 1), _ref14),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4186 10.0001C17.4186 10.0231 17.4372 10.0417 17.4603 10.0417C17.4833 10.0417 17.5019 10.0231 17.5019 10C17.5019 9.97704 17.4833 9.95837 17.4603 9.95835C17.4492 9.95833 17.4386 9.96273 17.4308 9.97056C17.4229 9.97839 17.4185 9.98901 17.4186 10.0001",
    stroke: "#7A7670",
    style: (_ref15 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref15, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref15, "strokeOpacity", 1), _ref15),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3744 10.5021H9.4978",
    stroke: "#7A7670",
    style: (_ref16 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref16, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref16, "strokeOpacity", 1), _ref16),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.49789 10.5022V5.83167",
    stroke: "#7A7670",
    style: (_ref17 = {
      stroke: "#7A7670"
    }, _defineProperty(_ref17, "stroke", "color(display-p3 0.4784 0.4627 0.4392)"), _defineProperty(_ref17, "strokeOpacity", 1), _ref17),
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingRaiseVoiceV3);
export default __webpack_public_path__ + "static/media/trainingRaiseVoiceV3.a8afcaadb286cb59ecb809ee4462e5d7.svg";
export { ForwardRef as ReactComponent };